export default "__VITE_ASSET__CXAh9eK9__"